export default "__VITE_ASSET__xFdyeo72__"